import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const SalesWorkPlanner = () => {
  return <DepartmentWorkPlanner department="sales" departmentName="Sales Department" />;
};

export default SalesWorkPlanner;
